<template>
  <div ref="PAIES" class="section">
    <section-header v-if="!hideTitle"
                    :ressource="ressource"
                    :isExtended="extended"
                    :dialog="dialog"
                    @extended=setExtended
                    ref="PAIES">
    </section-header>

    <div v-if="extended">
      <div v-for="(state, indexState) in states" :key="indexState" :class="dialog ? 'p-15' : 'pt-2 pb-5'">
        <div class="text" v-html="state.info"></div>

        <div class="d-flex flex-row-reverse">
          <loader-button v-for="(action, indexAction) in state.actions" :key="indexAction" class="ms-2"
                         type="submit"
                         :label="action"
                         :outlined="outlined(indexState, indexAction)"
                         @callback="callBack(indexState, indexAction)">
          </loader-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
  import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton } from '@/ressources/globalRessources';
  import Paie from '@/generated/classes/Paie';
  import { Extended } from '@/framework/base/classes/Schema';
  import { storePaie } from '@/generated/stores';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import Contrat from '@/generated/classes/Contrat';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import { DateFormat } from '@/framework/base/helpers/DateFormat';
  import State from '@/generated/classes/State';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import { SectionStatus } from '@/framework/base/components/FieldInfo';
  import { FieldStatus } from '@/framework/base/components/FieldInfo';
  import { defineComponent, type PropType } from "vue";

  export default defineComponent({
    name: 'SectionPaies',
    components: {
      SectionHeader,
      LoaderButton
    },
    props: {
      hideTitle: {
        type: Boolean,
        required: false,
      },
      extended: {
        type: Boolean,
        required: false,
      },
      dialog: {
        type: Boolean,
        required: false,
      },
      contrat: {
        type: Object as PropType<Contrat>,
        required: false,
      },
    },
    data () {
      const listStates: State[] = [];
      const lockActions: boolean[] = [];
      return {
        listStates,
        lockActions,
        status: new SectionStatus(false, false, false)
      };
    },
    computed: {
      ressource (): any { return RessourceGenSection(GenSection.PAIES); },
      saveLabel (): any {
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },
      states (): State[] {
        storePaie.listPaie.filter(a => a.contratId === this.contrat.id).sort((p1, p2) => p1.id - p2.id).forEach((paie) => {
          const exists = this.listStates.find(a => a.objId == paie.id);
          if (exists) {
            if (exists.statut != paie.statut) {
              const index = this.listStates.indexOf(exists);
              this.callBack(index);

            }
          } else {
            const state = new State();
            state.objType = ObjTypes.PAIE;
            state.objId = paie.id;
            state.statut = paie.statut;
            this.listStates.push(state);
            this.lockActions.push(false);
            this.callBack(this.listStates.length - 1);
          }
        });
        return this.listStates;
      },
    },
    methods: {
      outlined (indexState: number, indexAction: number) {
        let res = false;
        const state = this.listStates[indexState];
        if (state.outlined && state.outlined.length >= indexAction) {
          res = state.outlined[indexAction];
        }
        return res;
      },
      setExtended (extended: Extended): void {
        this.$emit('extended', extended);
      },
      callBack (stateIndex: number, actionIndex?: number) {
        if (!this.lockActions[stateIndex]) {
          this.lockActions[stateIndex] = true;
          if (actionIndex != null) {
            this.states[stateIndex].actionIndex = actionIndex + 1;
          } else {
            this.states[stateIndex].actionIndex = 0;
          }
          State.process(this.states[stateIndex]).then((res) => {
            this.states[stateIndex].info = res.info;
            this.states[stateIndex].actions = res.actions;
            this.states[stateIndex].statut = res.statut;
            this.states[stateIndex].outlined = res.outlined;
            this.lockActions[stateIndex] = false;
          }).catch(() => {
            this.lockActions[stateIndex] = false;
          });

        }
      },
    },
  });
</script>


<style scoped>
  td {
    padding: 10px !important;
  }
</style>